// никаких внешних href в HTML: внешнее — через redirect-эндпоинт
document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-external]");
    if (!btn) return;
    const key = btn.getAttribute("data-external");
    if (key === "github") window.location.href = "/external/github";
});

// Mobile topbar menu + auto-hide on scroll
(function () {
    const topbar = document.querySelector("[data-topbar]");
    const toggleBtn = document.querySelector("[data-topbar-toggle]");
    const actions = document.getElementById("topActions");
    if (!topbar || !toggleBtn || !actions) return;

    function isMobile() {
        return window.matchMedia("(max-width: 640px)").matches;
    }

    function setOpen(open) {
        if (!isMobile()) return;
        actions.classList.toggle("open", open);
        toggleBtn.setAttribute("aria-expanded", open ? "true" : "false");
    }

    toggleBtn.addEventListener("click", () => {
        const open = !actions.classList.contains("open");
        setOpen(open);
    });

    // click outside closes menu
    document.addEventListener("click", (e) => {
        if (!isMobile()) return;
        if (topbar.contains(e.target)) return;
        setOpen(false);
    });

    // esc closes
    document.addEventListener("keydown", (e) => {
        if (!isMobile()) return;
        if (e.key === "Escape") setOpen(false);
    });

    // if switching to desktop, keep actions visible via CSS and drop state
    window.addEventListener("resize", () => {
        if (!isMobile()) {
        actions.classList.remove("open");
        toggleBtn.setAttribute("aria-expanded", "false");
        topbar.classList.remove("is-hidden");
        }
    });

    // auto-hide on scroll (mobile only)
    let lastY = window.scrollY;
    let ticking = false;

    window.addEventListener("scroll", () => {
        if (!isMobile()) return;
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
        const y = window.scrollY;

        // если меню открыто — не прячем шапку, иначе бесит
        const menuOpen = actions.classList.contains("open");

        if (!menuOpen) {
            if (y > lastY + 8 && y > 80) {
            topbar.classList.add("is-hidden");
            } else if (y < lastY - 8) {
            topbar.classList.remove("is-hidden");
            }
        }

        lastY = y;
        ticking = false;
        });
    }, { passive: true });
})();